module.exports = __webpack_public_path__ + "img/jhsys4.19be7f4b.png";